<template>
  <div id="portal">
    <div v-if="isBrowserCompatibility">
      <Nav></Nav>
    </div>
    <div v-else>
      <BrowserCompatibility></BrowserCompatibility>
    </div>
  </div>
</template>

<script>
import Nav from './components/nav/Nav.vue';
import BrowserCompatibility from './components/browser/browser-compatibility.vue';
import { checkBrowserVersion } from './utils/tools';
import mutationTypes from './store/mutation-types';

export default {
  components: {
    Nav,
    BrowserCompatibility
  },

  data() {
    return {
      isBrowserCompatibility: true
    }
  },

  created() {
    this.isBrowserCompatibility = checkBrowserVersion();
  }
}
</script>

<style>
.mono-app-container{
  margin: 0;
  padding: 0;
}

.mono-content {
  position: absolute;
  top: 50px;
  left: 240px;
  bottom: 0;
  right: 0;
  min-width: 1000px;
  transition: all 0.3s ease-in-out 0s;
}

.mono-content.collapsed {
  left: 55px;
  min-width: 1100px;
  transition: all 0.3s ease-in-out 0s;
}

.mono-content.allscreen {
  left: 0;
  min-width: 1100px;
  transition: all 0.3s ease-in-out 0s;
}
</style>